export const locationsInputs = ['name', 'coordinates-longitude', 'coordinates-latitude', 'areaSize']
